// Lightweight event bus for projectL
const listeners = new Map();

export function on(event, handler) {
  if (!listeners.has(event)) listeners.set(event, new Set());
  listeners.get(event).add(handler);
}

export function off(event, handler) {
  if (!listeners.has(event)) return;
  listeners.get(event).delete(handler);
}

export function once(event, handler) {
  const wrapper = (...args) => {
    handler(...args);
    off(event, wrapper);
  };
  on(event, wrapper);
}

export function emit(event, payload) {
  const set = listeners.get(event);
  if (!set) return;
  for (const handler of Array.from(set)) {
    try {
      handler(payload);
    } catch (err) {
      // swallow handler errors to avoid breaking emitters
      // but log for visibility

      console.error('[eventBus] handler error', err);
    }
  }
}

export function clearAll() {
  listeners.clear();
}

export default { on, off, once, emit, clearAll };
